import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

export type CatalystDrawerParams = (
  | { type: 'company'; entityTag: string; insightId: string }
  | { type: 'market'; themeId: string; insightId: string }
) & { source: PosthogTrackingSource };

export const useCatalystDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const { trackCatalystDrawerOpen } = usePosthogEvents();

  const openDrawer = (drawerParams: CatalystDrawerParams) => {
    trackCatalystDrawerOpen(drawerParams.source, drawerParams.type);

    if (drawerParams.type === 'company') {
      setQueryParams({
        [queryKeys.activeDrawer]: queryValues.catalystInsightsDrawer,
        [queryKeys.type]: drawerParams.type,
        [queryKeys.entityTag]: drawerParams.entityTag,
        [queryKeys.insightId]: drawerParams.insightId,
      });
    } else {
      setQueryParams({
        [queryKeys.activeDrawer]: queryValues.catalystInsightsDrawer,
        [queryKeys.type]: drawerParams.type,
        [queryKeys.themeId]: drawerParams.themeId,
        [queryKeys.insightId]: drawerParams.insightId,
      });
    }
  };

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.type,
      queryKeys.entityTag,
      queryKeys.themeId,
      queryKeys.insightId,
      queryKeys.utmSource,
      queryKeys.utmCampaign,
    ]);

  const isOpen = params.activeDrawer === queryValues.catalystInsightsDrawer;

  return {
    closeDrawer,
    openDrawer,
    isOpen,
    drawerType: params[queryKeys.type],
    entityTag: params[queryKeys.entityTag],
    themeId: params[queryKeys.themeId],
    insightId: params[queryKeys.insightId],
    utmSource: params[queryKeys.utmSource],
  };
};
